// extracted by mini-css-extract-plugin
export default {"container":"TenantCreate_container__smaA5"};